<template>
  <v-app id="inspire">
    <v-card-title>
      Release File Data
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="getReleaseFile"
      :hide-default-footer="true"
      disable-pagination
      item-key="id"
    >
      <!-- ACTIONS -->
      <template v-slot:item.actions="{ item }">
        <!-- DELETE PACKAGE BUTTON -->
        <v-btn icon @click="deleteReleaseFile(item.id)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <c-confirmation-dialog ref="confirmationDialog"></c-confirmation-dialog>
  </v-app>
</template>

<script>
import {
  GET_RELEASE_FILE_QUERY,
  DELETE_RELEASE_FILE,
} from '../../graphql/upgradePackageQueries.js';

export default {
  created() {
    this.refetchReleaseFiles();
  },
  components: {
    CConfirmationDialog: () => import('../common/CConfirmationDialog'),
  },
  data() {
    return {
      id: '',
      search: '',
      headers: [
        { text: 'ID', value: 'id', align: 'left', sortable: false },
        { text: 'Unit Type ID', value: 'unitTypeId', sortable: true },
        { text: 'Product ID', value: 'productId', sortable: true },
        { text: 'Application ID', value: 'applicationId', sortable: true },
        { text: 'Version', value: 'version', sortable: true },
        { text: 'Binary File ID', value: 'binaryFileId', sortable: false },
        {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'right',
          width: '10%',
        },
      ],
      getReleaseFile: [],
    };
  },
  apollo: {
    $client: 'upgradePackageClient',
    getReleaseFile: {
      query: GET_RELEASE_FILE_QUERY,
      loadingKey: 'loading',
    },
  },
  methods: {
    refetchReleaseFiles() {
      this.$apollo.queries.getReleaseFile.refetch();
    },
    async deleteReleaseFile(id) {
      console.log(this.$refs.confirmationDialog);
      if (
        await this.$refs.confirmationDialog.open(
          'Are you sure you want to delete this file?'
        )
      ) {
        try {
          const response = await this.$apollo.mutate({
            mutation: DELETE_RELEASE_FILE,
            variables: {
              id: id,
            },
          });
          console.log(response);
          this.refetchReleaseFiles();
        } catch (error) {
          alert('Error deleting file! ' + error.message);
        }
      }
    },
  },
};
</script>
